export default "__VITE_ASSET__$iUbQbUm__"